import { ContentTypeFilterClause, ExplorableItemDefinition } from './ContentDefinitionsTypes';
import { Messages } from '../../../codegen/Localize';
import { CustomViewsContentType } from '../ContentTypes';
import { getGenericDefaultFilters } from './getDefaultFilters';
import { GenericCard } from '../../../app/spaces/CardView/GenericCard';
import { ServerFilterClauses } from '../../helpers/ServerFilterClauses';
import { CustomViews } from '../../ServerApi/CustomViews/CustomViews';

export const CustomViewDefinition: ExplorableItemDefinition = {
  itemType: 'customView',
  pluralName: Messages.customViews,
  emptyStateMessage: Messages.workbooksCustomViewsEmptyMessage,
  contentFilterKeys: CustomViewsContentType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: GenericCard,
  listViewIconUrl: null,
  filterClause: ServerFilterClauses.ContentType(['customView']) as ContentTypeFilterClause,
  getBasicQuery: () => {
    return CustomViews.all().withExtraParams(CustomViewsContentType.extraQueryParams);
  },
  getContentInfo: () => {
  },
  supportedDisplayModes: ['list'],
};
